import React from 'react';
import { graphql } from 'react-apollo';
import { ToastContainer } from 'react-toastr';
import SUBSCRIBE_MUTATION from '../../../graphql/Subscribe';

class Subscribe extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
    };
  }

  onChange = (evt) => {
    const { name, value } = evt.target;
    this.setState({ [name]: value });
  };

  onSubmit = (evt) => {
    evt.preventDefault();

    const { name, email } = this.state;
    this.props.mutate({
      variables: {
        name,
        email,
      },
    }).then(({ data }) => {
      if (data.subscribe.success) {
        this.toastr.success(data.subscribe.message);
      } else {
        this.toastr.warning(data.subscribe.message);
      }
    }).catch((err) => {
      console.log(err);
      this.toastr.error('Ocurrió un problema al intentar ingresar tu suscripción');
    });
  };

  render() {
    const { name, email } = this.state;
    return (
      <div className="newsletter">
        <ToastContainer
          ref={(ref) => { this.toastr = ref; }}
          className="toast-top-right"
        />
        <h2 className="title">Newsletter</h2>
        <div className="f-text">
          Ingresa tu nombre y correo electrónico para suscribirte a nuestro Newsletter
        </div>

        <form onSubmit={this.onSubmit}>
          <p>
            <input
              className="nsu-field btn-block"
              id="nsu-email-0"
              type="text"
              onChange={this.onChange}
              name="name"
              placeholder="Ingresa tu nombre"
              required
              value={name}
            />
          </p>
          <p>
            <input
              className="nsu-field btn-block"
              id="nsu-email-0"
              type="email"
              onChange={this.onChange}
              name="email"
              placeholder="Ingresa tu correo electrónico"
              required
              value={email}
            />
          </p>

          <p>
            <button
              type="submit"
              className="button-sm button-theme btn-block"
            >
              Suscribirme
            </button>
          </p>
        </form>
      </div>
    );
  }
}

const withMutation = graphql(SUBSCRIBE_MUTATION);

export default withMutation(Subscribe);



// WEBPACK FOOTER //
// ./src/containers/Others/Subscribe/index.js